import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setClassificationApiBaseUrl(url) {
    api.setBaseUrl(url);
}
export async function listTopics(includeDeleted = false) {
    return api.get(`/api/topics${includeDeleted ? '?includeDeleted=true' : ''}`);
}
export async function createTopic(body) {
    return api.post('/api/topics', body);
}
export async function updateTopic(id, body) {
    return api.patch(`/api/topics/${id}`, body);
}
export async function deleteTopic(id) {
    const r = await api.del(`/api/topics/${id}`);
    if (!r.ok)
        throw new Error(`delete failed ${r.status}`);
}
export async function restoreTopic(id) {
    const r = await api.fetchRaw(`/api/topics/${id}/restore`, { method: 'POST' });
    if (!r.ok)
        throw new Error(`restore failed ${r.status}`);
}
//# sourceMappingURL=api.js.map